/**
 * ROTAS69 — tabbed product showcase.
 *
 * Every panel is server-rendered, so switching a tab only moves one class between nodes that
 * already exist. Nothing is fetched, inserted or re-written.
 *
 * Listeners are delegated on the document so a section re-render in the theme editor needs no
 * re-wiring. The state class is r69best-current, deliberately not `is-active` — names used inside
 * the theme's :has() rules make every flip pay a document-wide style recalc.
 */
(() => {
  if (window.__r69TabbedProducts) return;
  window.__r69TabbedProducts = true;

  const CURRENT = 'r69best-current';

  function activate(tab) {
    const root = tab.closest('[data-r69best]');
    if (!root) return;
    const id = tab.getAttribute('data-r69best-tab');

    root.querySelectorAll('[data-r69best-tab]').forEach((el) => {
      const on = el === tab;
      el.classList.toggle(CURRENT, on);
      el.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    root.querySelectorAll('[data-r69best-panel]').forEach((panel) => {
      panel.classList.toggle(CURRENT, panel.getAttribute('data-r69best-panel') === id);
      // The hidden panels sit under the current one with visibility: hidden, so r69-lazy.js parks
      // their card images instead of loading them (see the note there); the panel just shown
      // must have its images re-armed, or they stay blank.
      if (panel.classList.contains(CURRENT) && window.r69Lazy) window.r69Lazy.watch(panel);
    });
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-r69best-tab]');
    if (tab) activate(tab);
  });

  // Roving arrow keys across the tablist, which is what a role="tablist" is expected to do.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    const tab = event.target.closest('[data-r69best-tab]');
    if (!tab) return;
    const tabs = Array.from(tab.closest('[data-r69best]').querySelectorAll('[data-r69best-tab]'));
    const next = tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1);
    const target = tabs[(next + tabs.length) % tabs.length];
    event.preventDefault();
    target.focus();
    activate(target);
  });
})();
